<template>
  <div class="list-root" v-loading.fullscreen.lock="fullscreenLoading">
    <query-condition-box>
      <el-form
        :inline="true"
        size="small"
        :model="searchParams"
        class="demo-form-inline"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item>
              <el-input
                v-model.trim="searchParams.userId"
                style="width: 200px"
                placeholder="请输入用户ID"
                type="number"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="searchClick"
                >查询
              </el-button>
            </el-form-item>
            <span>
              <el-button
                v-if="
                  $store.state.user.userInfo.userTypeId !==
                  shopCenterConst.role.boss
                "
                style="float: right"
                type="primary"
                icon="el-icon-plus"
                size="small"
                @click="openEmployeeDialog(operationType.add)"
                >添加{{ shopOrStudioTag === "工作室" ? `成员` : `店员` }}
              </el-button>
              <el-dialog
                id="z-dialog"
                width="28%"
                top="30vh"
                :title="dialogTitle"
                :visible.sync="dialogFormVisible"
                @closed="closeDialog"
              >
                <el-form
                  id="dialogForm"
                  @submit.native.prevent
                  :model="form"
                  label-width="100px"
                >
                  <el-form-item label="用户ID" required>
                    <el-input
                      clearable
                      @input="userIdChange"
                      :disabled="usernIdDisabled"
                      style="width: 100%"
                      v-model.trim="form.userId"
                      autocomplete="off"
                      placeholder="请输入用户ID"
                    ></el-input>
                    <div class="el-form-item__error">{{ dialogErrorMsg }}</div>
                  </el-form-item>
                  <el-form-item label="身份" required style="margin-top: 10px">
                    <el-select
                      clearable
                      :disabled="roleDisalbed"
                      style="width: 100%"
                      v-model="form.userTypeId"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in userTypeIdOpt"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="资产权限" required>
                    <el-radio-group
                      @input="radioChange"
                      v-model="form.hasWithdraw"
                    >
                      <el-radio v-if="form.userTypeId !== 1" :label="0"
                        >无</el-radio
                      >
                      <el-radio :disabled="radioDisabled" :label="1"
                        >提现</el-radio
                      >
                      <el-radio
                        v-if="
                          $store.state.user.userInfo.organizationTypeId === 1 ||
                          ($store.state.user.userInfo.organizationTypeId ===
                            2 &&
                            $store.state.user.userInfo.shopTypeId === 65)
                        "
                        :disabled="radioDisabled"
                        :label="2"
                        >分配收入</el-radio
                      >
                    </el-radio-group>
                  </el-form-item>
                  <br />
                  <span
                    style="
                      display: flex;
                      justify-content: center;
                      font-size: 12px;
                      color: rgb(128, 128, 128);
                      height: 16px;
                    "
                    >{{ dialogTip }}</span
                  >
                </el-form>
                <div slot="footer" class="dialog-footer">
                  <el-button
                    type="primary"
                    @click="okDialog"
                    :loading="dialogButtonLoading"
                    >确 定</el-button
                  >
                </div>
              </el-dialog>
              <auth-dialog
                :dialog-visible.sync="auth.flag"
                :tip-type="auth.tipType"
              ></auth-dialog>
            </span>
          </el-col>
        </el-row>
      </el-form>
    </query-condition-box>
    <div class="result-container">
      <xkw-table
        :header-cell-style="{ background: '#f8f8f9', 'text-align': 'center' }"
        v-loading="loading"
        :data="tableList"
        v-model="tableName"
      >
        <el-table-column
          :show-overflow-tooltip="true"
          prop="userId"
          label="用户ID"
          align="center"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          prop="username"
          label="用户名"
          align="center"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="createTime"
          label="身份"
        >
          <template v-slot="{ row }">
            <span v-if="row.userTypeId === 1">{{
              shopOrStudioTag === "工作室" ? `主持人` : `店主`
            }}</span>
            <span v-if="row.userTypeId === 2">{{
              shopOrStudioTag === "工作室" ? `成员` : `店员`
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="操作"
          v-if="
            $store.state.user.userInfo.userTypeId !== shopCenterConst.role.boss
          "
        >
          <template v-slot="{ row }">
            <el-link
              @click="openEmployeeDialog(row)"
              :underline="false"
              type="primary"
              >&nbsp;修改&nbsp;
            </el-link>
            <el-link
              v-if="row.userTypeId === 2"
              :underline="false"
              type="primary"
              @click="delEmployee(row)"
              >&nbsp;删除&nbsp;
            </el-link>
          </template>
        </el-table-column>
      </xkw-table>
      <el-pagination
        v-if="total !== null && total !== 0"
        background
        style="text-align: right; padding: 10px"
        :current-page.sync="searchParams.pageIndex"
        layout="total, prev, pager, next, jumper"
        :total="total"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import api from "../../assets/js/api";
import AuthDialog from "@/components/auth-dialog.vue";
import { isOpenPermissionDialog, isPersonalShop } from "@/assets/js/utils";
import shopCenterConst from "@/assets/js/shopCenterConst";
import store from "@/store";

export default {
  computed: {
    shopCenterConst() {
      return shopCenterConst;
    },
    shopOrStudioTag: () => {
      return store.getters["user/shopOrStudioTag"];
    },
  },
  components: { AuthDialog },
  data() {
    return {
      auth: {
        flag: false,
        tipType: null,
      },
      fullscreenLoading: false,
      dialogFormVisible: false,
      operationType: {
        add: `添加${this.shopOrStudioTag === "工作室" ? "成员" : "店员"}`,
        updateEmployee: `修改${
          this.shopOrStudioTag === "工作室" ? "成员" : "店员"
        }`,
        updateBoss: `添加${
          this.shopOrStudioTag === "工作室" ? "主持人" : "店主"
        }`,
      },
      dialogTitle: "",
      dialogTip: "",
      dialogErrorMsg: null,
      dialogButtonLoading: false,
      usernIdDisabled: false,
      roleDisalbed: false,
      radioDisabled: false,
      form: {
        userId: null,
        //username: null,
        userTypeId: null,
        hasWithdraw: null,
        shopId: this.$store.state.user.userInfo.shopId,
      },
      userTypeIdOpt: [],
      tableList: [],
      loading: false,
      tableName: "员工列表",
      total: 0,
      searchParams: {
        pageSize: 10,
        pageIndex: 1,
        userId: null,
        shopId: this.$store.state.user.userInfo.shopId,
      },
    };
  },
  created() {
    this.getTableList();
  },
  mounted() {},
  methods: {
    radioChange(value) {
      switch (value) {
        case 0:
          this.dialogTip = "";
          break;
        case 1:
          this.dialogTip = `可提现${this.shopOrStudioTag}全部资产`;
          break;
        case 2:
          this.dialogTip = `可按${
            this.shopOrStudioTag === "工作室" ? "成员" : "店员"
          }计算并转账相关资产`;
      }
    },
    requestParams() {
      if (!this.form.userId) {
        this.$message.error("请输入用户ID");
        return false;
      }
      if (!this.form.userTypeId) {
        this.$message.error("请选择身份");
        return false;
      }
      if (this.form.hasWithdraw == null) {
        this.$message.error("请选择资产权限");
        return false;
      }
      return true;
    },
    async userIdChange(value) {
      this.dialogErrorMsg = "";
      if (!value) {
        this.form.hasWithdraw = null;
        this.dialogTip = "";
        this.radioDisabled = false;
        return;
      }
      if (!isPersonalShop(this.$store.state.user.userInfo)) {
        return;
      }
      const res = await this.$axios.get(api.employee.isRealName, {
        username: value,
      });
      if (res.valid && !res.result) {
        this.form.hasWithdraw = 0;
        this.dialogTip = "完成店铺认证后解锁";
        this.radioDisabled = true;
      }
    },
    async addEmployee() {
      this.dialogButtonLoading = true;
      this.dialogErrorMsg = "";
      const res = await this.$axios.post(api.employee.addEmployee, this.form);
      if (!res.valid && res.error.message) {
        this.dialogErrorMsg = res.error.message;
      } else if (res.valid && res.result) {
        this.$message.success("添加成功");
        this.searchClick();
        this.dialogFormVisible = false;
      }
      this.dialogButtonLoading = false;
    },
    async updateEmployee() {
      this.dialogButtonLoading = true;
      this.dialogErrorMsg = "";
      if (!this.requestParams()) {
        this.dialogButtonLoading = false;
        return;
      }
      const res = await this.$axios.post(
        api.employee.updateEmployee,
        this.form
      );
      if (res.valid && res.result) {
        this.$message.success("修改成功");
        this.searchClick();
        this.dialogFormVisible = false;
      } else {
        this.$message.error("修改失败");
      }
      this.dialogButtonLoading = false;
    },
    okDialog() {
      if (!this.requestParams()) {
        this.dialogButtonLoading = false;
        return;
      }
      switch (this.dialogTitle) {
        case this.operationType.add:
          this.addEmployee();
          break;
        case this.operationType.updateEmployee:
          this.updateEmployee();
          break;
        case this.operationType.updateBoss:
          this.updateEmployee();
          break;
      }
    },
    openEmployeeDialog(row) {
      //  auth start;
      const type = isOpenPermissionDialog(this.$store.state.user.userInfo);
      if (type === 1 || type === 3) {
        this.auth.tipType = type;
        this.auth.flag = true;
        return;
      }
      //  auth end;
      if (row === this.operationType.add) {
        this.dialogTitle = this.operationType.add;
        this.userTypeIdOpt = [
          {
            value: 2,
            label: `${this.shopOrStudioTag === "工作室" ? "成员" : "店员"}`,
          },
        ];
      }
      if (isPersonalShop(this.$store.state.user.userInfo)) {
        this.userIdChange(row.userId);
      } else {
        if (!this.$store.state.user.userInfo.hasRealNameAuth) {
          this.form.hasWithdraw = 0;
          this.dialogTip = "完成店铺认证后解锁";
          this.radioDisabled = true;
        }
      }
      switch (row.userTypeId) {
        case 1:
          this.dialogTitle = this.operationType.updateBoss;
          this.userTypeIdOpt = [
            {
              value: 1,
              label: `${this.shopOrStudioTag === "工作室" ? "主持人" : "店主"}`,
            },
            {
              value: 2,
              label: `${this.shopOrStudioTag === "工作室" ? "成员" : "店员"}`,
            },
          ];
          this.usernIdDisabled = true;
          this.roleDisalbed = true;
          Object.assign(this.form, row);
          break;
        case 2:
          this.dialogTitle = this.operationType.updateEmployee;
          this.userTypeIdOpt = [
            {
              value: 2,
              label: `${this.shopOrStudioTag === "工作室" ? "成员" : "店员"}`,
            },
          ];
          this.usernIdDisabled = true;
          Object.assign(this.form, row);
          break;
      }
      if (this.form.hasWithdraw) {
        this.radioChange(this.form.hasWithdraw);
      }
      this.dialogFormVisible = true;
    },
    closeDialog() {
      this.form.userId = null;
      this.form.userTypeId = null;
      this.form.hasWithdraw = null;
      this.dialogTitle = "";
      this.dialogTip = "";
      this.usernIdDisabled = false;
      this.roleDisalbed = false;
      this.dialogErrorMsg = "";
      this.radioDisabled = false;
    },
    async delEmployee(row) {
      //  auth start;
      const type = isOpenPermissionDialog(this.$store.state.user.userInfo);
      if (type === 1 || type === 3) {
        this.auth.tipType = type;
        this.auth.flag = true;
        return;
      }
      //  auth end;
      let _that = this;
      this.$confirm("删除后无法进入商家中心，是否确定删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await _that.$axios.post(api.employee.delEmployee, {
            userId: row.userId,
            shopId: row.shopId,
          });
          if (res.valid && res.result) {
            _that.$message.success("删除成功");
            await _that.searchClick();
          } else {
            _that.$message.error("删除失败");
          }
        })
        .catch(() => {});
    },
    //搜索按钮
    searchClick() {
      this.searchParams.pageIndex = 1;
      this.getTableList();
    },
    //获取列表
    async getTableList() {
      this.loading = true;
      const tableList = await this.$axios.post(
        api.employee.getEmployeeList,
        this.searchParams
      );
      this.tableList = tableList.list;
      this.total = tableList.totalCount;
      this.loading = false;
    },
    // 修改当前页
    handleCurrentChange(pageIndex) {
      this.searchParams.pageIndex = pageIndex;
      //请求
      this.getTableList();
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  appearance: none;
}
.result-container {
  padding: 20px;
  background: #fff;
  border-radius: 5px;
}

::v-deep .el-dialog__footer {
  text-align: center;
}

::v-deep #dialogForm .el-form-item__content {
  margin-left: 20px !important;
}
::v-deep #z-dialog .el-dialog__body {
  padding-bottom: 10px;
}
</style>
